import {
  BookedTravelerInt,
} from "@interfaces/*";
import { InternationFlow } from "./internationFlow.model";
import { Passenger } from "./passenger.model";

export class Infant extends Passenger {

  public adultAssociate: Passenger | null = null;

  constructor(passenger?: BookedTravelerInt,adultAssociate?:Passenger){
    super(passenger);
    if(passenger && adultAssociate){
      this.adultAssociate = adultAssociate;
      this.internationFlow = new InternationFlow(adultAssociate.missingCheckinRequiredFields);
    }
  }

}
